import type { Candidate } from '@/services/api'
import { Badge } from '@/shared/components/Badge'
import { estiloDeEstatus } from '@/features/rh/lib/estatusDeCandidato'
import { colorDeEstatusDeCandidato } from '@/features/rh/lib/colorDeEstatusDeCandidato'

/**
 * El estatus de un candidato con el Badge compartido: aquí solo se decide el
 * texto y el color. Sin icono adentro: en una tabla repite lo que ya dice la
 * etiqueta.
 */
export const CandidatoStatusBadge = ({
  status,
  className = '',
}: {
  status: Candidate['status'] | string
  className?: string
}) => {
  const { label } = estiloDeEstatus(status)

  return (
    <Badge color={colorDeEstatusDeCandidato(status)} className={className}>
      {label}
    </Badge>
  )
}

export default CandidatoStatusBadge
